var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text_content"},[_c('div',{class:['rep_con', _vm.fontSize],domProps:{"innerHTML":_vm._s(_vm.processedRichText || _vm.textContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }